import { reduxForm } from 'redux-form';

import {
  QueuesTeamsTableDispatchProps,
  QueuesTeamsTableFormValues,
  QueuesTeamsTable as QueuesTeamsTableImpl,
  QueuesTeamsTableOwnProps,
  QueuesTeamsTableStateProps,
} from '../components/queuesTeamsTable';

const FORM_NAME = 'queuesTeamsTableForm';

const QueuesTeamsTableForm = reduxForm<
  QueuesTeamsTableFormValues,
  QueuesTeamsTableOwnProps &
    QueuesTeamsTableStateProps &
    QueuesTeamsTableDispatchProps
>({
  form: FORM_NAME,
  enableReinitialize: true,
})(QueuesTeamsTableImpl);

export { QueuesTeamsTableForm as QueuesTeamsTable };
